export default "__VITE_ASSET__Sd_GSb5E__"